// extracted by mini-css-extract-plugin
export default {"loginContainer":"login_loginContainer__60tar","formGroup":"login_formGroup__rF2ne","label":"login_label__MNJ7Y","input":"login_input__BKdbq","button":"login_button__nhc0M"};